import gql from 'graphql-tag'
import { fragment } from './getClosing'

export default gql`
mutation updateClosingMoney($id: ID!, $fields: ClosingFieldsMoney, $reason: String) {
    cashAssist {
      updateClosingMoney(id: $id, fields: $fields, reason: $reason){
				...getClosingFragment
      }
    }
}
${fragment}`
